// NPM Imports
import React from "react";
import { connect } from "react-redux";

// Components Imports
import DealTableGrid from "./DealTableGridV2";
import DealTableFooter from "./DealTableFooter";

function DealTable(props) {
  return (
    <div className={`dealtable-container ${props.isLocked ? "is-locked" : ""}`}>
      <div className="dealtable-grid-wrapper">
        <DealTableGrid />
        <DealTableFooter />
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  const {
    document: { isLocked = false },
  } = state.DocumentStore;
  return { isLocked };
};

export default connect(mapStateToProps)(DealTable);
